export default __webpack_public_path__ + "static/media/overlay.cc0063df.png";